import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAdminAuth } from '../hooks/useAdminAuth';
import { UnauthorizedAccess } from './ProtectedRoute';

export default function AdminProtectedRoute() {
  const { isAdmin, isLoading, user } = useAdminAuth();
  const location = useLocation();

  console.log('🛡️ AdminProtectedRoute:', { isAdmin, isLoading });

  if (isLoading) {
    console.log('⏳ Still loading admin status...');
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p>Verifying admin access...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    console.log('❌ Not signed in, redirecting to login');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Signed in but not an admin: say so. Sending them to /login bounced them
  // straight on to the map with no explanation.
  if (!isAdmin) {
    console.log('❌ Not admin');
    return <UnauthorizedAccess requiredRole="admin" />;
  }

  console.log('✅ Admin access granted!');
  return <Outlet />;
}
